module.exports = __webpack_public_path__ + "static/media/2016_conf_Intro_Andre_Marquet.b518c1bb.png";